import { ToolState } from 'cornerstone-tools';

class ElementToolStateManager {
  private toolState: Record<string, ToolState> = {};
  private element: HTMLElement;

  constructor(element: HTMLElement) {
    this.toolState = {};
    this.element = element;
  }

  get = (_element: HTMLElement, toolName: string): ToolState | undefined =>
    this.toolState[toolName];

  add = (_element: HTMLElement, toolName: string, data: any): void => {
    if (!this.toolState[toolName]) {
      this.toolState[toolName] = { data: [] };
    }
    this.toolState[toolName].data.push(data);
  };

  clear = (): void => {
    this.toolState = {};
  };
}

export { ElementToolStateManager };
